import { isEqual } from './isEqual';

export const getFilteredInfoCb =
  ({ entranceName, filters, onClearSelectedFlats }) =>
  (prev) => {
    const isClear = isEqual(prev[entranceName], filters);

    if (!isClear) onClearSelectedFlats();

    if (prev[entranceName] !== filters) {
      return { ...prev, [entranceName]: filters };
    }

    return prev;
  };
